import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Image, Palette, FormatColorFill, Opacity } from "@mui/icons-material";

interface ExportModalProps {
  open: boolean;
  onClose: () => void;
  onExportWithBackground: () => void;
  onExportPaletteOnly: () => void;
  onExportColorPalette: () => void;
  onExportTransparent: () => void;
}

const ExportModal: React.FC<ExportModalProps> = ({
  open,
  onClose,
  onExportWithBackground,
  onExportPaletteOnly,
  onExportColorPalette,
  onExportTransparent,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Export Options</DialogTitle>
      <DialogContent>
        <List>
          <ListItem 
            component="button" 
            onClick={onExportWithBackground}
            sx={{ 
              borderRadius: 1, 
              mb: 1,
              '&:hover': { backgroundColor: 'action.hover' }
            }}
          >
            <ListItemIcon>
              <Image />
            </ListItemIcon>
            <ListItemText 
              primary="Export with Background" 
              secondary="Color dots overlaid on faded image (PNG)"
            />
          </ListItem>
          <ListItem 
            component="button" 
            onClick={onExportTransparent}
            sx={{ 
              borderRadius: 1, 
              mb: 1,
              '&:hover': { backgroundColor: 'action.hover' }
            }}
          >
            <ListItemIcon>
              <Opacity />
            </ListItemIcon>
            <ListItemText 
              primary="Export with Transparent Background" 
              secondary="Color dots only, no background (PNG)"
            />
          </ListItem>
          <ListItem 
            component="button" 
            onClick={onExportPaletteOnly}
            sx={{ 
              borderRadius: 1, 
              mb: 1,
              '&:hover': { backgroundColor: 'action.hover' }
            }}
          >
            <ListItemIcon>
              <Palette />
            </ListItemIcon>
            <ListItemText 
              primary="Export Palette on White" 
              secondary="Color dots on white background with border (PNG)"
            />
          </ListItem>
          <ListItem 
            component="button" 
            onClick={onExportColorPalette}
            sx={{ 
              borderRadius: 1,
              '&:hover': { backgroundColor: 'action.hover' }
            }}
          >
            <ListItemIcon>
              <FormatColorFill />
            </ListItemIcon>
            <ListItemText 
              primary="Export Color Swatches" 
              secondary="Grid of color swatches with hex codes (PNG)"
            />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportModal;